import { createAction } from "@reduxjs/toolkit";
import _omit from 'lodash/omit';
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

const attributes = ['id', 'text', 'medias', 'channel', 'sender', 'status', 'created_at'];

export const getMessages = asyncThunkWrapper({ 
  model: 'messages', 
  action: 'getMessages', 
  func: async ({ offset = 0, conversation_id, direction = null, my_id = null, statuses = [], senders = [] }) => {
    const params = { 
      limit: 25, 
      offset, 
      orders: { updated_at: 'desc' }, 
      attributes, 
      ...(!!statuses.length && { statuses }),
      ...(!!senders.length && { senders })
    };
    const response =  await axios.get(`/conversations/${conversation_id}/messages`, { params });

    return { data: response.data, direction, my_id };
  } 
});
export const getMessage = asyncThunkWrapper({ 
  model: 'messages', 
  action: 'getMessage', 
  func: async ({ cable = false, message_id }) => {
    const params = { attributes };
    const response = await axios.get(`/messages/${message_id}`, { params });

    return { data: response.data, cable };
  } 
});
export const createMessage = asyncThunkWrapper({ 
  model: 'messages', 
  action: 'createMessage', 
  func: async ({ message, conversation_id, local_id }) => {
    const data = { message: _omit(message, 'localMedias'), attributes };
    const response = await axios.post(`/conversations/${conversation_id}/messages`, data);

    return { data: response.data, local_id, conversation_id };
  } 
});
export const deleteMessage = asyncThunkWrapper({ 
  model: 'messages', 
  action: 'deleteMessage', 
  func: async (id) => {
    const response = await axios.delete(`/messages/${id}`);

    return { status: response.status, id };
  } 
});
export const approveMessage = asyncThunkWrapper({ 
  model: 'messages', 
  action: 'approveMessage', 
  func: async (id) => {
    const response = await axios.post(`/messages/${id}/approve`);

    return { status: response.status, id };
  } 
});
export const rejectMessage = asyncThunkWrapper({ 
  model: 'messages', 
  action: 'rejectMessage', 
  func: async (id) => {
    const response = await axios.post(`/messages/${id}/reject`);

    return { status: response.status, id };
  } 
});
export const createLocalMessage = createAction('messages/createLocalMessage');
export const deleteLocalMessage = createAction('messages/deleteLocalMessage');
export const setLocalMessageError = createAction('messages/setLocalMessageError');
export const setLocalMessageFields = createAction('messages/setLocalMessageFields');
export const clearLocalMessages = createAction('messages/clearLocalMessages');
export const clearLocalActiveMessage = createAction('messages/clearLocalActiveMessage');